const ROLES = {
    SUPER_ADMIN: 'Super Admin',
    COR_SUPER_ADMIN: 'Corporate Super Admin',
    SUPERVISOR_ADMIN: 'Supervisor Admin',
    PROFESSIONAL: 'Professional',
    CONSUMER: 'Consumer',
    FREE_APP_SUITE: 'Free App Suite',
    VIEW_ONLY: 'View Only'
}

export default ROLES














